import "flatpickr/dist/themes/material_blue.css"
import styled from "styled-components"
import Ext_Date from "src/core/components/MyControl/Ext_Date"
import classNames from "classnames"
import { Dropdown, DropdownMenu, DropdownToggle, Input } from "reactstrap"
import { isNotEmpty } from "src/core/helpers/utils"
import { IoClose } from "react-icons/io5"
import { HEE } from "@macashipo/mlib"
import React, { RefObject, memo, useEffect, useState } from "react"
import C from "src/core/helpers/c"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
import { DayPickerRangeController } from "react-dates"

import moment from "moment"
import "moment/locale/vi" // Import ngôn ngữ tiếng Việt
import { MyModal } from "src/core/components"

moment.locale("vi")

const step = 30 //minus
const stepSplit = 15

interface DatePickerProps {
  value?: any
  tabActive?: any
  timeShowDatePicker?: any
  isMobileView?: any
  arrDayDisabled?: any
  onUpdate?: any
  configSelectDate?: any
}

const DatePicker = memo<DatePickerProps>(
  ({
    value,
    tabActive,
    timeShowDatePicker,
    isMobileView,
    arrDayDisabled,
    onUpdate,
    configSelectDate,
  }) => {
    const getDisabledNearstGreater = (time: any, arr: any) => {
      let timeNear = 0

      arr?.forEach(item => {
        if (time < item && (item < timeNear || !timeNear)) {
          timeNear = item
        }
      })
      return timeNear
    }
    const [timeStartShow, timeEndShow] = timeShowDatePicker || []
    const [startValue, endValue] = value || []
    const startValuePicker = startValue ? moment(startValue) : null
    const endValuePicker = endValue ? moment(endValue) : null
    const timeStartValue = startValuePicker
      ? startValuePicker.startOf("day")
      : null
    const timeDisabledNearst = getDisabledNearstGreater(
      timeStartValue,
      arrDayDisabled
    )
    return (
      <WrapPicker className="d-flex justify-content-center">
        <DayPickerRangeController
          startDate={startValuePicker} // Start date of the selected range
          startDateId={"startDate"}
          focusedInput={tabActive === 0 ? "startDate" : "endDate"}
          // focusedInput={"startDate"}
          endDate={endValuePicker} // End date of the selected range
          endDateId={"endDate"}
          renderDayContents={(dayMoment, classSet) => {
            let isHovered = false
            if (classSet && classSet?.has("hovered")) {
              isHovered = true
            }
            let tooltip = <></>
            if (
              classSet &&
              classSet?.has("selected-end") &&
              !classSet?.has("selected-start")
            ) {
              tooltip = (
                <div className="date-tooltip">
                  {configSelectDate?.labelTo}
                  <div className="triangle-tooltip" />
                </div>
              )
            } else if (
              classSet &&
              classSet?.has("selected-start") &&
              !classSet?.has("selected-end") &&
              !classSet?.has("selected-start-no-selected-end")
            ) {
              tooltip = (
                <div className="date-tooltip">
                  {configSelectDate?.labelFrom}
                  <div className="triangle-tooltip" />
                </div>
              )
            }

            return (
              <div className={`picker-date ${isHovered && "is-hovered-end"}`}>
                {dayMoment?.date()}
                {tooltip}
              </div>
            )
          }}
          isDayBlocked={day => {
            const milisecondsDay = day?.valueOf()
            const toDate = new Date()
            toDate.setHours(0, 0, 0, 0)
            if (timeStartValue && timeStartValue && tabActive === 1) {
              if (
                milisecondsDay < timeStartValue ||
                (milisecondsDay > timeDisabledNearst && timeDisabledNearst)
              ) {
                return true
              }
            }

            if (arrDayDisabled?.includes(milisecondsDay)) {
              return true
            }

            return milisecondsDay < toDate.getTime()
          }}
          onDatesChange={({ startDate, endDate }) => {
            startDate && startDate.startOf("day")
            endDate && endDate.startOf("day")
            let rsStart = startDate
              ? new Date(startDate?.valueOf()).setMinutes(Number(timeStartShow))
              : null
            let rsEnd = endDate
              ? new Date(endDate?.valueOf()).setMinutes(Number(timeEndShow))
              : null
            const dateResult = [rsStart, rsEnd]
            onUpdate && onUpdate(dateResult)
          }} // Function to update state when dates change
          navPrev={
            <div className="DayPickerNavigation_button__horizontalDefault DayPickerNavigation_button__default DayPickerNavigation_leftButton__horizontalDefault">
              <i className="flaticon-left-arrow" />
            </div>
          }
          navNext={
            <div className="DayPickerNavigation_button__horizontalDefault DayPickerNavigation_button__default DayPickerNavigation_rightButton__horizontalDefault">
              <i className="flaticon-right-arrow" />
            </div>
          }
          minimumNights={0}
          hideKeyboardShortcutsPanel
          daySize={isMobileView ? 38 : 48}
          monthFormat="[Tháng] M/YYYY"
          initialVisibleMonth={() => {
            if (startValuePicker) {
              return startValuePicker
            }
            return moment()
          }} // The month that is initially visible
          numberOfMonths={isMobileView ? 1 : 2} // Number of months to show in the calendar
        />
      </WrapPicker>
    )
  }
)

const WrapPicker = styled.div`
  & .DayPicker_transitionContainer {
    height: 336px !important;
    z-index: 2;
    pointer-events: none;
  }
  & .CalendarMonth_table {
    pointer-events: auto;
  }
  & .DayPicker_focusRegion {
    position: relative;
    z-index: 3;
  }
  & .CalendarMonth,
  & .CalendarMonthGrid {
    background: transparent;
  }
  & .DayPicker__withBorder {
    box-shadow: none;
  }
  & .CalendarDay__default {
    vertical-align: middle;
    border-color: transparent;
    position: relative;
    z-index: 4;
    border: none !important;
    overflow: visible;
    background: transparent !important;
    & .picker-date {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 1px solid transparent;
      &:hover {
        border: 1px solid #000;
      }
      &:active,
      &:hover {
        & .date-tooltip {
          display: block;
        }
      }
    }
    &.CalendarDay__firstDayOfWeek {
      & .date-tooltip {
        left: 0;
        transform: translate(0%, -100%) translate(0px, -12px);
        & .triangle-tooltip {
          &:before,
          &:after {
            left: 25%;
          }
        }
      }
    }
    &.CalendarDay__lastDayOfWeek {
      & .date-tooltip {
        left: unset;
        right: 0;
        transform: translate(0%, -100%) translate(0px, -12px);
        & .triangle-tooltip {
          &:before {
            left: unset;
            right: 0;
          }
          &:after {
            left: unset;
            right: 0;
          }
        }
      }
    }
    & .date-tooltip {
      position: absolute;
      z-index: 4;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%) translate(0, -12px);
      color: var(--den);
      border: 1px solid #d9d9d9;
      background: #fff;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
      white-space: nowrap;
      padding: 4px 8px;
      display: none;
      & .triangle-tooltip {
        &:before {
          left: 50%;
          transform: translate(-50%, 3px);
          position: absolute;
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 9px solid #fff;
          z-index: 2;
        }
        &:after {
          z-index: 1;
          left: 50%;
          transform: translate(-50%, 4px);
          position: absolute;
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #d9d9d9;
        }
      }
    }
    &.CalendarDay__blocked_calendar {
      & .picker-date {
        text-decoration: line-through;
        &:hover {
          border: 1px solid transparent;
        }
      }
    }
  }
  .DayPickerNavigation_button__default {
    color: var(--den);
    border: none !important;
  }
  & .CalendarDay__selected_start {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
  }
  & .CalendarDay__selected_end {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  }
  & .CalendarDay__default.CalendarDay__selected,
  & .CalendarDay__default.CalendarDay__selected_span,
  & .CalendarDay__default.CalendarDay__hovered_span {
    position: relative;
    z-index: 4;
    background: var(--color-bg-inrange-calendar) !important;
    color: var(--den);
  }

  &
    .CalendarDay__default.CalendarDay__selected.CalendarDay__selected_start_no_selected_end {
    background: transparent !important;
  }
  &
    .CalendarDay__default.CalendarDay__selected.CalendarDay__selected_start_no_selected_end.CalendarDay__selected_start_in_hovered_span {
    background: var(--color-bg-inrange-calendar) !important;
  }

  & .CalendarDay__default.CalendarDay__selected {
    & .picker-date {
      background: var(--den);
      color: #fff;
    }
  }
  &
    .CalendarDay__default.CalendarDay__hovered_span.CalendarDay__after_hovered_start {
    background: transparent !important;
  }
  & .CalendarDay__default.CalendarDay__hovered_span:hover {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    & .picker-date {
      border: 1px solid #000;
    }
  }
  @media (max-width: 1010px) {
    & .DayPicker_transitionContainer {
      height: 306px !important;
    }
    & .DayPicker {
      margin-left: -24px;
      margin-right: -24px;
      padding-left: 12px;
      padding-right: 12px;
    }
    & .DayPicker_weekHeader,
    & .CalendarMonth {
      padding: 0 !important;
    }
    & .DayPickerNavigation_leftButton__horizontalDefault {
      left: 10px;
    }
    & .DayPickerNavigation_rightButton__horizontalDefault {
      right: 34px;
    }
  }
`

class SelectTimeFromTo extends React.Component<any, any> {
  refTimeUpdate: React.RefObject<ReturnType<typeof setTimeout> | null>
  constructor(props) {
    super(props)
    this.refTimeUpdate = React.createRef()
  }

  componentDidMount(): void {
    const ro = new ResizeObserver((entries, observer) => {
      const { isMobileView } = this.state
      for (const entry of entries) {
        const { left, top, width, height } = entry.contentRect
        if (entry.target == document.body) {
          if (width <= 1010) {
            if (isMobileView === false) {
              console.log(
                `RO Mobile Element's size: ${width}px x ${height}px`,
                isMobileView
              )
            }
            this.setIsMobileView(true)
          } else {
            this.setIsMobileView(false)
          }
        }
      }
    })
    ro.observe(document.body)
  }

  onClearTime = step => {
    const [start, end] = this.state.value
    let valueUpdate: any = []
    let newTabActive = 0
    if (step === 1 && start) {
      valueUpdate = [start, null]
      newTabActive = 1
    }

    this.setState(
      {
        value: valueUpdate,
        valueToUpdate: valueUpdate,
        tabActive: newTabActive,
      },
      () => {
        this.onHandleUpdateValue(valueUpdate)
      }
    )
  }

  onHandleUpdateValue = valueUpdate => {
    const { fnList } = this.props
    fnList?.onUpdateDateValue &&
      fnList?.onUpdateDateValue(valueUpdate, {
        cbSuccess: data => {
          if (data) {
            this.setState({ defaultValues: data })
          }
        },
      })
  }

  initState = () => {
    let st: any = {}
    const dfValue = this.props.data
    const controlOpts = this.props.controlOpts
    const { getDefaultValues } = controlOpts || {}
    const defaultValues = getDefaultValues && getDefaultValues()
    st.tabActive = this.props.tabActive ?? 0
    if (dfValue && dfValue?.length > 0) {
      const [start, end] = dfValue
      const dateStart =
        start && !Number.isNaN(start) && new Date(Number(start)).getTime()
      const dateEnd =
        end && !Number.isNaN(end) && new Date(Number(end)).getTime()
      const dfValueFormat = [dateStart || null, dateEnd || null]
      let timeStart: any = 0
      let timeEnd: any = 0
      if (dateStart) {
        const currentDate = new Date(dateStart).getTime()
        const currentDateAtZero = new Date(dateStart).setHours(0, 0, 0, 0)
        timeStart = (currentDate - currentDateAtZero) / 60000
      }
      if (dateEnd) {
        const currentDate = new Date(dateEnd).getTime()
        const currentDateAtZero = new Date(dateEnd).setHours(0, 0, 0, 0)
        timeEnd = (currentDate - currentDateAtZero) / 60000
      }
      st.timeStart = timeStart
      st.timeEnd = timeEnd
      st.timeStartShow = timeStart
      st.timeEndShow = timeEnd
      st.timeShowDatePicker = [timeStart, timeEnd]
      st.value = dfValueFormat
      st.valueToUpdate = dfValueFormat
      st.defaultValues = defaultValues
    }
    return st
  }

  state = {
    ...this.initState(),
  }

  getValueToShow = ({
    showEndTime = false,
    needMergeText = false,
  }: any = {}) => {
    const { value } = this.state
    const [start, end] = value
    const { controlOpts = {} } = this.props
    const { configSelectDate } = controlOpts
    let _timeStart: any = ""
    let _timeEnd: any = ""
    let dateStart: any = ""
    let dateEnd: any = ""
    let _break = "-"
    if (configSelectDate?.breakCharacter) {
      _break = configSelectDate?.breakCharacter
    }
    if (start) {
      const _dateStart = new Date(start)
      const y = _dateStart?.getFullYear()
      const m = _dateStart?.getMonth() + 1
      const d = _dateStart?.getDate()
      let formattedDate = `${d < 10 ? `0${d}` : d}/${m < 10 ? `0${m}` : m}/${y}`
      let hours: any = new Date(_dateStart).getHours()
      let minute: any = new Date(_dateStart).getMinutes()
      _timeStart = `${hours < 10 ? `0${hours}` : hours}:${
        minute < 10 ? `0${minute}` : minute
      }`
      dateStart = _timeStart + " - " + formattedDate
    }
    if (end) {
      const _dateEnd = new Date(end)
      const y = _dateEnd?.getFullYear()
      const m = _dateEnd?.getMonth() + 1
      const d = _dateEnd?.getDate()
      let formattedDate = `${d < 10 ? `0${d}` : d}/${m < 10 ? `0${m}` : m}/${y}`
      let hours: any = new Date(_dateEnd).getHours()
      let minute: any = new Date(_dateEnd).getMinutes()
      _timeEnd = `${hours < 10 ? `0${hours}` : hours}:${
        minute < 10 ? `0${minute}` : minute
      }`
      dateEnd = _timeEnd + " - " + formattedDate
    }
    let _dateTimeStart = dateStart
    let _dateTimeEnd = dateEnd

    if (!needMergeText) {
      if (showEndTime) {
        if (_dateTimeEnd) {
          return _dateTimeEnd
        }
        return configSelectDate?.placeholderTo || ""
      }
      return _dateTimeStart ? _dateTimeStart : configSelectDate?.placeholderFrom
    } else {
      if (!start || !end) {
        return configSelectDate?.descriptionPicker || ""
      }
      if (_dateTimeEnd !== " ") {
        return dateStart + " - " + dateEnd
      }
      return dateStart
    }
  }

  onHandleChangeTab = index => {
    this.setState({
      tabActive: index,
    })
  }

  onHandleUpdateDate = dateResult => {
    const { fnList } = this.props
    const { tabActive } = this.state
    const [rsStart, rsEnd] = dateResult
    let newTabActive = tabActive

    if ((rsStart && !rsEnd) || tabActive === 0) {
      newTabActive = 1
    }
    this.setState(
      {
        value: dateResult,
        valueToUpdate: dateResult,
        tabActive: newTabActive,
      },
      () => {
        this.onHandleUpdateValue(dateResult)
      }
    )
  }

  getTimeText = index => {
    const { value, timeStartShow, timeEndShow } = this.state
    const _dateTmp = new Date().setHours(0, 0, 0, 0)
    const resetTimeOfValue = new Date(_dateTmp).setHours(0, 0, 0, 0)
    let _time = new Date(resetTimeOfValue).setMinutes(Number(timeStartShow))
    if (index === 1) {
      _time = new Date(resetTimeOfValue).setMinutes(Number(timeEndShow))
    }
    let hours: any = new Date(_time).getHours()
    let minute: any = new Date(_time).getMinutes()
    if (new Date(_time).getHours() < 10) {
      hours = "0" + new Date(_time).getHours()
    }
    if (new Date(_time).getMinutes() < 10) {
      minute = "0" + new Date(_time).getMinutes()
    }
    return hours + ":" + minute
  }

  onHandleChangeTime = (index, newVal, field) => {
    let fieldShow = field === "timeStart" ? "timeStartShow" : "timeEndShow"
    let valueShow = (Math.round(Number(newVal) / step) * step).toString()
    this.setState(
      {
        [field]: newVal,
        [fieldShow]: valueShow,
      },
      () => {
        this.onHandleUpdateTimeValue(valueShow, index)
      }
    )
  }

  onHandleUpdateTimeValue = (values, index) => {
    const { fnList } = this.props
    if (this.refTimeUpdate.current) {
      clearTimeout(this.refTimeUpdate.current)
    }
    this.refTimeUpdate = {
      current: setTimeout(() => {
        const times = this.getTimeList()
        const rs = times.find(v => v?.Value === values)
        const { value, timeStartShow, timeEndShow } = this.state
        let _newValues: any = [...value]
        const resetTimeOfValue = new Date(value[index]).setHours(0, 0, 0, 0)
        const newDate = new Date(resetTimeOfValue).setMinutes(Number(rs?.Value))
        _newValues[index] = newDate
        this.setState(
          {
            value: _newValues,
            timeShowDatePicker: [timeStartShow, timeEndShow],
            valueToUpdate: _newValues,
          },
          () => {
            this.onHandleUpdateValue(_newValues)
          }
        )
      }, 300),
    }
  }

  setIsMobileView = isMobile => {
    this.setState({
      isMobileView: isMobile,
    })
  }

  getTimeList = () => {
    return [
      { Value: "0", Text: "00:00" },
      { Value: "30", Text: "00:30" },
      { Value: "60", Text: "01:00" },
      { Value: "90", Text: "01:30" },
      { Value: "120", Text: "02:00" },
      { Value: "150", Text: "02:30" },
      { Value: "180", Text: "03:00" },
      { Value: "210", Text: "03:30" },
      { Value: "240", Text: "04:00" },
      { Value: "270", Text: "04:30" },
      { Value: "300", Text: "05:00" },
      { Value: "330", Text: "05:30" },
      { Value: "360", Text: "06:00" },
      { Value: "390", Text: "06:30" },
      { Value: "420", Text: "07:00" },
      { Value: "450", Text: "07:30" },
      { Value: "480", Text: "08:00" },
      { Value: "510", Text: "08:30" },
      { Value: "540", Text: "09:00" },
      { Value: "570", Text: "09:30" },
      { Value: "600", Text: "10:00" },
      { Value: "630", Text: "10:30" },
      { Value: "660", Text: "11:00" },
      { Value: "690", Text: "11:30" },
      { Value: "720", Text: "12:00" },
      { Value: "750", Text: "12:30" },
      { Value: "780", Text: "13:00" },
      { Value: "810", Text: "13:30" },
      { Value: "840", Text: "14:00" },
      { Value: "870", Text: "14:30" },
      { Value: "900", Text: "15:00" },
      { Value: "930", Text: "15:30" },
      { Value: "960", Text: "16:00" },
      { Value: "990", Text: "16:30" },
      { Value: "1020", Text: "17:00" },
      { Value: "1050", Text: "17:30" },
      { Value: "1080", Text: "18:00" },
      { Value: "1110", Text: "18:30" },
      { Value: "1140", Text: "19:00" },
      { Value: "1170", Text: "19:30" },
      { Value: "1200", Text: "20:00" },
      { Value: "1230", Text: "20:30" },
      { Value: "1260", Text: "21:00" },
      { Value: "1290", Text: "21:30" },
      { Value: "1320", Text: "22:00" },
      { Value: "1350", Text: "22:30" },
      { Value: "1380", Text: "23:00" },
      { Value: "1410", Text: "23:30" },
    ]
  }
  onHandleSaveSelectecTime = () => {
    const { valueToUpdate } = this.state
    const { fnList, isPopup } = this.props
    isPopup && MyModal.hideModalComponent()
    fnList?.onToggleDropdownSelectTime &&
      fnList?.onToggleDropdownSelectTime(false)
    fnList?.afterSaveSelectTime && fnList?.afterSaveSelectTime(valueToUpdate)
  }

  render() {
    const {
      controlOpts = {},
      widthBtnDisplay,
      arrDayDisabled,
      isPopup,
    } = this.props
    const { configSelectDate, configSelectTime } = controlOpts
    const {
      value = [],
      tabActive,
      isMobileView,
      timeShowDatePicker,
      timeStart,
      timeEnd,
      defaultValues,
    } = this.state
    const [startValue, endValue] = value
    return (
      <WrapSelectFromTo className={`${isPopup && "is-show-popup"}`}>
        <div className="wrap-time">
          <div className="header-dropdown">
            <div className="wrap-title">
              <div className="title-picker">
                {defaultValues?.RentalDayCount && value?.[0] && value?.[1]
                  ? defaultValues?.RentalDayCount
                  : configSelectDate.titleDatePicker}
              </div>
              <div className="description-picker">
                {defaultValues?.RentalDate && value?.[0] && value?.[1]
                  ? defaultValues?.RentalDate
                  : configSelectDate.descriptionPicker}
              </div>
            </div>
            <div
              className="btn-time-dropdown"
              style={{ width: isPopup ? "unset" : widthBtnDisplay }}
            >
              <div
                className={classNames(
                  "start item",
                  tabActive === 0 && "active"
                )}
                title={this.getValueToShow()}
                onClick={() => {
                  this.onHandleChangeTab(0)
                }}
              >
                <div className="title">{configSelectDate?.labelFrom}</div>
                <div className="time"> {this.getValueToShow()}</div>
                {startValue && tabActive === 0 && (
                  <button
                    className="btn-close-time"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      this.onClearTime(0)
                    }}
                  >
                    <IoClose size={16} color="#000" />
                  </button>
                )}
              </div>
              <div
                className={classNames(
                  "end item",
                  tabActive === 1 && "active",
                  !startValue && "is-disabled"
                )}
                title={this.getValueToShow({ showEndTime: true })}
                onClick={() => {
                  if (!startValue) {
                    return
                  }
                  this.onHandleChangeTab(1)
                }}
              >
                <div className="title">{configSelectDate?.labelTo}</div>
                <div className="time">
                  {" "}
                  {this.getValueToShow({ showEndTime: true })}
                </div>
                {endValue && tabActive === 1 && (
                  <button
                    className="btn-close-time"
                    onClick={e => {
                      if (!startValue) {
                        return
                      }
                      e.stopPropagation()
                      e.preventDefault()
                      this.onClearTime(1)
                    }}
                  >
                    <IoClose size={16} color="#000" />
                  </button>
                )}
              </div>
            </div>
          </div>
          <DatePicker
            value={value}
            arrDayDisabled={arrDayDisabled}
            isMobileView={isMobileView}
            tabActive={tabActive}
            timeShowDatePicker={timeShowDatePicker}
            onUpdate={this.onHandleUpdateDate}
            configSelectDate={configSelectDate}
          />
          <hr className="devive-line" />
          <WrapSelectTime className="wrap-select-time">
            <div className="one-select-time">
              <div className="wrap-selected-time">
                <div className="title">{configSelectTime?.titleTimeFrom}</div>
                <div className="time-selected">{this.getTimeText(0)}</div>
              </div>
              <Input
                type="range"
                value={timeStart}
                className="select-time"
                min={0}
                max={1410}
                step={step / stepSplit}
                onChange={e => {
                  let newVal = e.currentTarget.value
                  this.onHandleChangeTime(0, newVal, "timeStart")
                }}
              />
            </div>
            <div className="one-select-time">
              <div className="wrap-selected-time">
                <div className="title">{configSelectTime?.titleTimeTo}</div>
                <div className="time-selected">{this.getTimeText(1)}</div>
              </div>
              <Input
                type="range"
                value={timeEnd}
                className="select-time"
                min={0}
                max={1410}
                step={step / stepSplit}
                onChange={e => {
                  let newVal = e.currentTarget.value
                  this.onHandleChangeTime(1, newVal, "timeEnd")
                }}
              />
            </div>
          </WrapSelectTime>
        </div>
        <div className="d-flex justify-content-end align-items-center">
          <button
            className="btn btn-clear-date"
            onClick={() => {
              if (!value?.[0] && !value?.[1]) {
                return
              }
              this.onClearTime(0)
            }}
          >
            Xóa ngày
          </button>
          <button
            className={`btn btn-primary btn-close-dropdown ${
              !value?.[0] && !value?.[1] ? "close-disabled" : ""
            }`}
            disabled={!value?.[0] && !value?.[1]}
            onClick={() => {
              if (!value?.[0] && !value?.[1]) {
                return
              }
              this.onHandleSaveSelectecTime()
            }}
          >
            Lưu
          </button>
        </div>
      </WrapSelectFromTo>
    )
  }
}

const WrapSelectFromTo = styled.div`
  &.is-show-popup {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    & .wrap-time {
      flex: 1;
      overflow-y: auto;
      padding-right: 15px;
    }
    .btn-time-dropdown .item .time {
      white-space: nowrap;
    }
    & .btn-close-dropdown {
      margin-right: 15px;
    }
    & .wrap-select-time {
      padding: 0;
      & .one-select-time {
        width: 336px;
      }
    }
    & hr {
      margin: 0;
    }
  }
  & hr {
    border-color: var(--color-divider-line);
    background-color: var(--color-divider-line);
    margin: 0 30px 15px;
  }
  & .btn-time-dropdown {
    padding: 0;
    color: var(--color-text-search-bar);
    box-shadow: none;
    border: none;
    display: flex;
    width: 100%;
    align-items: stretch;
    border-bottom: 1px solid #67676780;
    border: 1px solid #67676780;
    border-radius: 10px;
    & > * {
      &:last=child {
        margin-right: 0;
      }
    }
    & .item {
      padding: 10px 12px;
      padding-right: 30px;
      text-align: left;
      width: 48%;
      position: relative;
      z-index: 1;
      cursor: pointer;
      flex: 1;
      & .title {
        font-weight: 700;
        color: var(--color-text-000);
        font-size: 14px;
      }
      & .time {
        padding-top: 5px;
        font-size: 16px;
        color: var(--color-text-search-bar);
      }
      &.active {
        border-radius: 10px;
        box-shadow: inset 0 0 0 2px var(--den) !important;
      }
      &.is-disabled {
        opacity: 0.6;
        cursor: unset;
      }
      & .btn-close-time {
        display: flex;
        width: 24px;
        height: 24px;
        transform: translateY(-50%);
        border: none;
        background: transparent;
        position: absolute;
        right: 0px;
        top: 50%;
        right: 12px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        padding: 0;
        &:hover {
          background: #ddd;
        }
      }
    }
  }
  & .wrap-title {
    margin-right: 40px;
    font-size: 14px;
    & .title-picker {
      font-weight: 700;
      font-size: 22px;
    }
    & .description-picker {
      color: #666;
      margin-top: 8px;
    }
  }

  & .header-dropdown {
    display: flex;
    justify-content: space-between;
  }
  & .btn-clear-date {
    margin-right: 16px;
    text-decoration: underline;
    font-weight: 700;
    color: var(--den) !important;
    border: none !important;
    &:hover {
      background: #f7f7f7;
    }
  }
  & .btn-close-dropdown {
    background: var(--den);
    min-width: 100px;
    border: none !important;
    font-weight: 700;
    &.close-disabled {
      opacity: 0.4;
      cursor: default;
    }
  }
  @media (max-width: 1010px) {
    & .header-dropdown {
      flex-direction: column;
    }
    & .wrap-title {
      margin-bottom: 16px;
    }
    & .devive-line {
      margin: 8px 0px !important;
    }
  }
`

const WrapSelectTime = styled.div`
  &.wrap-select-time {
    margin-top: 30px;
    padding: 0 30px;
    display: flex;
    margin-bottom: 15px;
    justify-content: space-between;
    align-items: center;
    & .one-select-time {
      width: 320px;
    }
    .wrap-selected-time {
      display: flex;
      margin-bottom: 15px;
      justify-content: space-between;
      align-items: center;
      & .title {
        font-size: 14px;
        color: var(--color-text-000);
      }
    }
    & .time-selected {
      padding: 5px 15px;
      border: 1px solid var(--color-border-c0);
      border-radius: 8px;
      font-weight: 700;
      font-size: 18px;
    }
    input[type="range"]::-webkit-slider-runnable-track {
      background: var(--color-text-000);
      height: 1px;
    }
    input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 21px;
      height: 21px;
      border-radius: 50%;
      background: var(--color-text-000);
      cursor: pointer;
      margin-top: -10px;
    }
    input[type="range"]::-moz-range-track {
      background: var(--color-text-000);
      height: 1px;
    }
    input[type="range"]::-moz-range-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: var(--color-text-000);
      cursor: pointer;
      margin-top: -10px;
    }
  }
  @media (max-width: 1010px) {
    &.wrap-select-time {
      margin-top: 16px;
      padding: 0;
      flex-direction: column;
      & .one-select-time {
        width: 100%;
      }
    }
  }
`

class MCInputDateFromToDetail extends Ext_Date {
  refTimeUpdate: React.RefObject<ReturnType<typeof setTimeout> | null>
  refWrapFromTo: React.RefObject<HTMLInputElement>
  refLayoutDisplayBtn: React.RefObject<any>
  tabActive: number
  constructor(props) {
    super(props)
    this.refTimeUpdate = React.createRef()
    this.refWrapFromTo = React.createRef()
    this.refLayoutDisplayBtn = React.createRef()
    this.tabActive = 0
  }
  initState = () => {
    let st: any = {}
    const dfValue = this.getDefaultValue()
    const controlOpts = this.getControlOpts()
    const { getDefaultValues } = controlOpts || {}
    const defaultValues = getDefaultValues && getDefaultValues()
    if (dfValue && dfValue?.length > 0) {
      const [start, end] = dfValue
      const dateStart =
        start && !Number.isNaN(start) && new Date(Number(start)).getTime()
      const dateEnd =
        end && !Number.isNaN(end) && new Date(Number(end)).getTime()
      const dfValueFormat = [dateStart || null, dateEnd || null]
      st.value = dfValueFormat
      st.defaultValues = defaultValues
    }
    return st
  }
  forceUpdateValueKey = 0

  getMoreProps = () => {
    const controlOpts = this.getControlOpts()
    return controlOpts.morePropsDateFlatPickr
  }
  getValueToShow = ({
    showEndTime = false,
    needMergeText = false,
  }: any = {}) => {
    const { value } = this.state
    const [start, end] = value
    const controlOpts: any = this.getControlOpts()
    const { placeholder, configSelectDate } = controlOpts || {}
    let _timeStart: any = ""
    let _timeEnd: any = ""
    let dateStart: any = ""
    let dateEnd: any = ""
    let _break = "-"
    if (configSelectDate?.breakCharacter) {
      _break = configSelectDate?.breakCharacter
    }
    if (start) {
      const _dateStart = new Date(start)
      const y = _dateStart?.getFullYear()
      const m = _dateStart?.getMonth() + 1
      const d = _dateStart?.getDate()
      let formattedDate = `${d < 10 ? `0${d}` : d}/${m < 10 ? `0${m}` : m}/${y}`
      let hours: any = new Date(_dateStart).getHours()
      let minute: any = new Date(_dateStart).getMinutes()
      _timeStart = `${hours < 10 ? `0${hours}` : hours}:${
        minute < 10 ? `0${minute}` : minute
      }`
      dateStart = _timeStart + " - " + formattedDate
    }
    if (end) {
      const _dateEnd = new Date(end)
      const y = _dateEnd?.getFullYear()
      const m = _dateEnd?.getMonth() + 1
      const d = _dateEnd?.getDate()
      let formattedDate = `${d < 10 ? `0${d}` : d}/${m < 10 ? `0${m}` : m}/${y}`
      let hours: any = new Date(_dateEnd).getHours()
      let minute: any = new Date(_dateEnd).getMinutes()
      _timeEnd = `${hours < 10 ? `0${hours}` : hours}:${
        minute < 10 ? `0${minute}` : minute
      }`
      dateEnd = _timeEnd + " - " + formattedDate
    }
    let _dateTimeStart = dateStart
    let _dateTimeEnd = dateEnd

    if (!needMergeText) {
      if (showEndTime) {
        if (_dateTimeEnd) {
          return _dateTimeEnd
        }
        return configSelectDate?.placeholderTo || ""
      }
      return _dateTimeStart ? _dateTimeStart : configSelectDate?.placeholderFrom
    } else {
      if (!start || !end) {
        return configSelectDate?.descriptionPicker || ""
      }
      if (_dateTimeEnd !== " ") {
        return dateStart + " - " + dateEnd
      }
      return dateStart
    }
  }

  state = {
    date: this.getDefaultValue(),
    ...this.initState(),
  }

  onToggleDropdownSelectTime = (newVal?: any) => {
    const { open, value } = this.state
    const controlOpts: any = this.getControlOpts()
    const { fnList } = controlOpts || {}
    let _newValue = !open
    if (isNotEmpty(newVal)) {
      _newValue = newVal
    }
    this.setState({
      open: _newValue,
      btnDisplayLayout: this.refLayoutDisplayBtn.current || {},
    })
    if (!_newValue) {
      fnList?.afterCloseSelectTime && fnList?.afterCloseSelectTime(value)
    }
  }

  onShowPopupSelectTime = () => {
    const { value, defaultValues } = this.state
    const controlOpts: any = this.getControlOpts()
    const { fnList = {} } = controlOpts || {}
    const _more = this.getMoreProps() || {}
    const arrDayDisabled = _more?.arrDayDisabled || []
    MyModal.showFromComponent(
      <SelectTimeFromTo
        isPopup={true}
        data={value}
        defaultValues={defaultValues}
        arrDayDisabled={arrDayDisabled}
        controlOpts={controlOpts}
        widthBtnDisplay={this.refLayoutDisplayBtn.current?.width}
        tabActive={this.tabActive}
        fnList={{
          ...fnList,
          onUpdateDateValue: this.onHandleUpdateValueControl,
        }}
      />,
      {
        title: "Chọn Thời gian",
        modalClassName:
          "default modal-filter modal_time_from_to modal-dialog-scrollable-new",
        modalScrollInside: true,
        titleBtnOK: "Đồng ý",
      }
    )
  }

  onHandleUpdateValueControl = (dateResult, { cbSuccess, cbError }) => {
    const controlOpts: any = this.getControlOpts()
    const { fnList = {} } = controlOpts || {}
    // this.setState({ value: dateResult }, () => {
    //   this.onUpdateValue(dateResult)
    // })
    this.onUpdateValue(dateResult)
    fnList?.updateDataToView &&
      fnList?.updateDataToView(dateResult, {
        cbSuccess,
        cbError,
      })
  }

  render() {
    const { open, value, btnDisplayLayout, defaultValues } = this.state
    const controlOpts: any = this.getControlOpts()
    const { configSelectDate, fnList = {} } = controlOpts || {}
    const _more = this.getMoreProps() || {}
    const arrDayDisabled = _more?.arrDayDisabled || []
    const isShowPopup = _more?.isShowPopup
    const forceUpdateValue = controlOpts.forceUpdateValueKey
    if (forceUpdateValue && forceUpdateValue !== this.forceUpdateValueKey) {
      this.forceUpdateValueKey = forceUpdateValue
      this.state.date = this.getDefaultValue()
    }

    return (
      <Wrap
        ref={this.refWrapFromTo}
        className={classNames("mc-input-date-from-to")}
        layoutBtn={btnDisplayLayout}
      >
        <div
          ref={ref => {
            if (ref?.offsetWidth && ref?.offsetHeight) {
              this.refLayoutDisplayBtn = {
                current: { height: ref?.offsetHeight, width: ref?.offsetWidth },
              }
            }
          }}
          style={
            open
              ? {
                  height: btnDisplayLayout?.height,
                }
              : {}
          }
          className={`btn-time-select display ${open && "is-open"}`}
        >
          <div
            className={classNames("start item")}
            title={this.getValueToShow()}
            onClick={() => {
              this.tabActive = 0
              if (open) {
                return
              }
              if (isShowPopup) {
                this.onShowPopupSelectTime()
                return
              }
              this.onToggleDropdownSelectTime(true)
              fnList?.onSetShowOverlay && fnList?.onSetShowOverlay(true)
            }}
          >
            <div className="title">{configSelectDate?.labelFrom}</div>
            <div className="time"> {this.getValueToShow()}</div>
          </div>
          <div className="devide-line" />
          <div
            className={classNames("end item")}
            title={this.getValueToShow({ showEndTime: true })}
            onClick={() => {
              this.tabActive = 1
              if (open) {
                return
              }
              if (isShowPopup) {
                this.onShowPopupSelectTime()
                return
              }
              this.onToggleDropdownSelectTime(true)
              fnList?.onSetShowOverlay && fnList?.onSetShowOverlay(true)
            }}
          >
            <div className="title">{configSelectDate?.labelTo}</div>
            <div className="time">
              {" "}
              {this.getValueToShow({ showEndTime: true })}
            </div>
          </div>
        </div>
        {!isShowPopup && (
          <Dropdown
            isOpen={open}
            direction="left"
            toggle={e => {
              if (this.refWrapFromTo.current && e.target) {
                if (this.refWrapFromTo.current.contains(e.target)) {
                  return
                }
              }

              this.onToggleDropdownSelectTime()
              fnList?.onSetShowOverlay && fnList?.onSetShowOverlay(false)
            }}
            className="cursor-context"
          >
            <DropdownToggle color="time-select"></DropdownToggle>
            <DropdownMenu
              className="datefromto-dropdown-menu"
              style={{
                transform: `translate(-${this.refLayoutDisplayBtn.current?.height}px)`,
              }}
            >
              {open && (
                <SelectTimeFromTo
                  data={value}
                  defaultValues={defaultValues}
                  arrDayDisabled={arrDayDisabled}
                  controlOpts={controlOpts}
                  widthBtnDisplay={this.refLayoutDisplayBtn.current?.width}
                  tabActive={this.tabActive}
                  fnList={{
                    ...fnList,
                    onUpdateDateValue: this.onHandleUpdateValueControl,
                    onToggleDropdownSelectTime: value => {
                      this.onToggleDropdownSelectTime(value)
                    },
                  }}
                />
              )}
            </DropdownMenu>
          </Dropdown>
        )}
      </Wrap>
    )
  }
}

const Wrap = styled.div<any>`
  & .datefromto-dropdown-menu {
    border-radius: 18px;
    padding: 20px;
    background-color: var(--color-text-fff);
    box-shadow: 0px 4px 10px 0px #00000040;
    left: unset !important;
    right: 0;
    transform: translate(
      20px,
      ${props => -(props.layoutBtn?.height ?? 0) - 21}px
    ) !important;
  }
  & .btn-time-select {
    padding: 0;
    color: var(--color-text-search-bar);
    box-shadow: none;
    border: none;
    display: flex;
    width: 100%;
    align-items: stretch;
    border-bottom: 1px solid #67676780;
    & .devide-line {
      border-right: 1px solid #67676780;
    }
    & > * {
      &:last=child {
        margin-right: 0;
      }
    }
    &.display {
      &.is-open {
        border-radius: 10px;
        box-shadow: inset 0 0 0 2px var(--den) !important;
      }
    }
    & .item {
      padding: 10px 12px;
      padding-right: 30px;
      text-align: left;
      width: 48%;
      position: relative;
      z-index: 1;
      cursor: pointer;
      flex: 1;
      & .title {
        font-weight: 700;
        color: var(--color-text-000);
        font-size: 14px;
      }
      & .time {
        padding-top: 5px;
        font-size: 16px;
        color: var(--color-text-search-bar);
      }
      &.active {
        border-radius: 10px;
        box-shadow: inset 0 0 0 2px var(--den) !important;
      }
      &.is-disabled {
        opacity: 0.6;
        cursor: unset;
      }
      & .btn-close-time {
        display: flex;
        width: 24px;
        height: 24px;
        transform: translateY(-50%);
        border: none;
        background: transparent;
        position: absolute;
        right: 0px;
        top: 50%;
        right: 12px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        padding: 0;
        &:hover {
          background: #ddd;
        }
      }
    }
    & .divider-line {
      border-left: 1px solid #d8d8d8;
      width: 1px;
      height: 30px;
    }
    & .divider-line.custom {
      margin-left: -5px;
    }
    & .text-merge {
      font-size: 14px;
      color: var(--color-text-search-bar);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  & .dropdown > .btn-time-select {
    border-bottom: none;
  }
  & .btn-time-select.custom-text {
    display: none;
  }
  & .btn-time-select:hover {
    box-shadow: none;
    color: var(--color-text-000);
  }
`
export default MCInputDateFromToDetail
